<div class="soc-media-block" [ngClass]="{ 'soc-media-block--last-child': socContactIndex === socContactsLength - 1 }">
  <p class="soc-media-block__title">
    {{ socContact.type | titlecase }}
    <span> {{ createPlaceholder(socContact.type) }} </span>
  </p>
  <bmcore-soc-media-input
    [socContact]="socContact"
    [placeholder]="createPlaceholder(socContact.type)"
    (updateContactsEvent)="updateContactsEvent.emit($event)"
  >
  </bmcore-soc-media-input>
</div>

@if (socContact?.type === contactsResultMessage?.type) {
  <div>
    <p
      [ngClass]="{
        'soc-media-block__error': contactsResultMessage.severity === 'error',
        'soc-media-block__success': contactsResultMessage.severity === 'success'
      }"
    >
      {{ contactsResultMessage.message }}
    </p>
  </div>
}
